
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/02ea8da4e3646162c7e568ae475e8d76.jpg"
              alt="TOZA MARKOVIC VPN Technology"
              title="TOZA MARKOVIC VPN Technology"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>

          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About TOZA MARKOVIC DOO KIKINDA
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Based in Kikinda, Serbia, TOZA MARKOVIC DOO KIKINDA is a leading software development company specializing in advanced security applications. Our mission is to provide individuals and businesses with powerful tools to protect their digital privacy and security.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Our flagship VPN application represents years of research and development in cybersecurity technology. We combine innovative encryption methods with user-friendly interfaces to deliver a product that anyone can use, regardless of technical expertise.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              We are committed to maintaining the highest standards of privacy protection, ensuring that our users can browse the internet freely and securely without compromising their personal information.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-6 border border-blue-100">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Location</h4>
                <p className="text-gray-600 text-sm">Kikinda, Serbia</p>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-6 border border-blue-100">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-star-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Expertise</h4>
                <p className="text-gray-600 text-sm">VPN Technology</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
